import { useEffect } from 'react'
import { useDialogs, useUser, useClientOptions } from '@paintscout/ui'
import { WelcomeSetupDialog } from '../dialogs'

export default function OnboardUser() {
  const { options } = useClientOptions()
  const { user, isTrial } = useUser()
  const { openDialog, dismissDialog, stack: dialogStack } = useDialogs()

  useEffect(() => {
    if (
      dialogStack.length === 0 &&
      isTrial &&
      user?.app_metadata?.roles?.includes('admin') && // if user is admin
      (!options.options.companyName.value || user?.app_metadata?.needsOnboarding)
    ) {
      openDialog(WelcomeSetupDialog, {
        onClose: dismissDialog
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
